import { IContent } from 'models/content.model';

export const content: IContent = {
  nl: {
    modalClose: 'Sluit venster',
  },
  en: {},
};
